import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import EstateMpProvider from "@/core/data-provider/data-mp/estate/estate-mp-provider.ts";
import useAppSelector from "@/core/helpers/useAppSelector";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response";
import { estateEnterInfoSelector } from "@/domains/estate/slice";
import toast from "@/domains/toasts/helpers/toast";

export default () => {
  const estate = useAppSelector(estateEnterInfoSelector);
  const { t } = useTranslation("estate");

  const enterEstate = useCallback(async () => {
    const response = await EstateMpProvider.enter(estate.id);
    if (response instanceof RpcMpProviderFailedResponse) {
      toast.error(t(`estate.errors.${response.message}`));
    }
  }, [estate.id, t]);

  const enterGarage = useCallback(async () => {
    const response = await EstateMpProvider.enterGarage(estate.id);
    if (response instanceof RpcMpProviderFailedResponse) {
      toast.error(t(`estate.errors.${response.message}`));
    }
  }, [estate.id, t]);

  return [enterEstate, enterGarage];
};
